export default __webpack_public_path__ + "static/media/gm20.da538be7.jpg";